<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">マルチ商品設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="split_two_part">
          <div class="element-column">
            <div class="column-list">
              <label class="list-input-title">マルチコード</label>
              <input type="text" class="list-input-content" readonly [(ngModel)]="model.multiCode" [style.width.rem]="10" />

              <div class="list-input-title layout_balance">
                <label>共通キャッチコピー</label>
                <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                  <fa-icon [icon]="iconQuestion"></fa-icon></label>
              </div>
              <app-not-null-text-area id="txt_CommonCatchcopy" #txt_CommonCatchcopy [forcedEnabledMode]="'true'"
                [maxChars]="200" [height]="70" [width]="600" [restrict]="'[ -￮]'" [allowMultiLine]="false"
                [tabEnabled]="true" [tabindex]="0" [displayCountField]="true"
                [(ngModel)]="model.commonCatchcopy" [fullOnly]="true"></app-not-null-text-area>

              <div class="list-input-title layout_balance">
                <label>共通商品説明</label>
                <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                  <fa-icon [icon]="iconQuestion"></fa-icon></label>
              </div>
              <app-not-null-text-area id="txt_CommonGoodsExplanation" #txt_CommonGoodsExplanation
                [forcedEnabledMode]="'true'" [maxChars]="200" [height]="70" [width]="600" [restrict]="'[ -￮]'" 
                [allowMultiLine]="false" [tabEnabled]="true" [tabindex]="0" [displayCountField]="true"
                [(ngModel)]="model.commonGoodsExplanation" [fullOnly]="true"></app-not-null-text-area>
            </div>
            <wj-flex-grid id="dtg_MultiGoodsList" #dtg_MultiGoodsList [itemsSource]="model.multiGoodsList"
              [headersVisibility]="'All'" [style.width.px]="822" [style.height.px]="259" [isReadOnly]="true"
              [tabindex]="-1" [selectionMode]="'Row'" [allowSorting]="false" [allowDragging]="'Rows'"
              (draggingRow)="onDraggingRow(dtg_MultiGoodsList, $event)"
              (draggedRow)="onDraggedRow(dtg_MultiGoodsList, $event)">
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]="'掲載順'" [binding]="'PublishSeq'"
                [align]="'right'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="85" [header]="'Ｐコード'"
                [binding]="'PCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="124" [header]="'商品名'"
                [binding]="'GuideGoodsName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'規格名'"
                [binding]="'GuideStandardName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="120" [header]="'メーカー名'"
                [binding]="'MakerName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'支払先取引先'"
                [binding]="'PayeeClient'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="130" [header]="'本登録日時'"
                [binding]="'RegistDate'"></wj-flex-grid-column>
            </wj-flex-grid>
          </div>

          <div>
            <h2>候補商品一覧</h2>
            <wj-flex-grid id="dtg_CandidateGoodsList" #dtg_CandidateGoodsList [itemsSource]="model.candidateGoodsList"
              [headersVisibility]="'Column'" [style.width.px]="819" [style.height.px]="420" [isReadOnly]="true"
              [tabindex]="0" [selectionMode]="'Row'">
              <wj-flex-grid-column [minWidth]="5" [width]="95" [header]="'マルチコード'"
                [binding]="'MultiCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="90" [header]="'Ｐコード'"
                [binding]="'PCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="116" [header]="'商品名'"
                [binding]="'GuideGoodsName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'規格名'"
                [binding]="'GuideStandardName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="120" [header]="'メーカー名'"
                [binding]="'MakerName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'支払先取引先'"
                [binding]="'PayeeClient'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="130" [header]="'本登録日時'"
                [binding]="'RegistDate'"></wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Set" class="btn-primary" (click)="eventCreateTargetListHandler()" forcedEnabledMode="'true'"
            [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>